"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_DAYS_BEFORE_TRANSACTION = exports.MAX_DAYS_AFTER_TRANSACTION = void 0;
// time range for searching invoices for a transaction
// only show invoices at most 7 days after the transaction date
exports.MAX_DAYS_AFTER_TRANSACTION = 7;
// only show invoices at most 180 days before the transaction date
exports.MAX_DAYS_BEFORE_TRANSACTION = 180;
//# sourceMappingURL=bank-transaction.js.map